/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/right.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Return the substring that extracts *length* chars from *str* starting from the right.
 *
 * @example
 * FROM employees
 * | KEEP last_name
 * | EVAL right = RIGHT(last_name, 3)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'right',
  signatures: [
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'length',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
        {
          name: 'length',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
